import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { reduxForm, Field } from 'redux-form';
import { isNameValid, isEmailValid, isPhoneNumberValid, isRequired } from '../utils/validator';
import { focusOnInput } from '../utils/FocusOnInput';

class GuardianFields extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      t,
      showLabel = true,
      handleSubmit,
      textInputComponent,
      textInputStyle
    } = this.props;

    return (
      <>
        <Field
          trim
          forwardRef
          name="name"
          showLabel={showLabel}
          placeholder={t('formFields:guardianName')}
          component={textInputComponent}
          returnKeyType="next"
          autoCapitalize="words"
          validate={isNameValid}
          onSubmitEditing={() => focusOnInput(this.lastnameInput)}
          ref={(ref) => { this.nameInput = ref; }}
          textInputStyle={textInputStyle}
        />
        <Field
          trim
          forwardRef
          name="lastname"
          showLabel={showLabel}
          placeholder={t('formFields:guardianLastname')}
          component={textInputComponent}
          returnKeyType="next"
          autoCapitalize="words"
          validate={isNameValid}
          onSubmitEditing={() => focusOnInput(this.contactNumberInput)}
          ref={(ref) => { this.lastnameInput = ref; }}
          textInputStyle={textInputStyle}
        />
        <Field
          trim
          forwardRef
          name="contactNumber"
          showLabel={showLabel}
          placeholder={t('formFields:guardianContactNumber')}
          component={textInputComponent}
          returnKeyType="next"
          keyboardType="numeric"
          validate={[isRequired, isPhoneNumberValid]}
          onSubmitEditing={() => focusOnInput(this.emailInput)}
          ref={(ref) => { this.contactNumberInput = ref; }}
          textInputStyle={textInputStyle}
        />
        <Field
          trim
          forwardRef
          name="email"
          showLabel={showLabel}
          placeholder={t('formFields:guardianEmail')}
          component={textInputComponent}
          returnKeyType="next"
          autoCapitalize="none"
          keyboardType="email-address"
          validate={isEmailValid}
          onSubmitEditing={() => focusOnInput(this.address)}
          ref={(ref) => { this.emailInput = ref; }}
          textInputStyle={textInputStyle}
        />
        <Field
          trim
          forwardRef
          name="address"
          showLabel={showLabel}
          placeholder={t('formFields:guardianAddress')}
          component={textInputComponent}
          returnKeyType="next"
          autoCapitalize="sentences"
          validate={isRequired}
          ref={(ref) => { this.address = ref; }}
          textInputStyle={textInputStyle}
        />
        <>
          {this.props.render({
            handleSubmit,
          })}
        </>
      </>
    );
  }
}

GuardianFields = translate(['auth', 'formFields'], { wait: true })(GuardianFields);
GuardianFields = reduxForm({ form: 'GuardianConsentForm', enableReinitialize: true, destroyOnUnmount: true })(GuardianFields);
export default GuardianFields;
